import { useState, useEffect } from 'react';


export function usePosts(tab: string) {
  const [posts, setPosts] = useState<any[]>([]);
  useEffect(() => {
    if (tab === 'battle') {
      fetch('/api/posts', { credentials: 'include' })
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data)) setPosts(data);
        });
    }
  }, [tab]);
  return { posts, setPosts };
}

// 댓글 등 post 관련 공통 액션 훅
export function usePostActions({
  postId,
  user,
  setComments,
}: {
  postId: string;
  user: any;
  setComments: (fn: (prev: any[]) => any[]) => void;
}) {
  // 댓글 등록
  const handleAddComment = async (commentInput: string, setCommentInput: (v: string) => void, setLoading: (v: boolean) => void, setError: (v: string) => void) => {
    if (!commentInput.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`/api/posts/comments?id=${postId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ content: commentInput })
      });
      const data = await res.json();
      if (data.success) {
        setComments(prev => [...prev, data.comment]);
        setCommentInput('');
      } else {
        setError(data.message || data.error || '댓글 등록 실패');
      }
    } catch (e) {
      setError('댓글 등록 중 오류');
    }
    setLoading(false);
  };

  // 댓글 삭제
  const handleDeleteComment = async (idx: number, comment: any) => {
    if (!postId || !comment || !window.confirm('정말 삭제하시겠습니까?')) return;
    try {
      const res = await fetch(`/api/posts/comments/delete?id=${postId}&idx=${idx}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      const data = await res.json();
      if (data.success) {
        setComments(prev => prev.filter((_, i) => i !== idx));
      } else {
        alert(data.message || '삭제 실패');
      }
    } catch {
      alert('삭제 중 오류');
    }
  };

  return { handleAddComment, handleDeleteComment };
} 